import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Select,
} from 'antd'
import { FilterFilled } from '@ant-design/icons'
import MessageFilterList from './message.filterlist'
import _ from 'lodash'
import '../../css/messages.scss'
import { useHistory } from 'react-router'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { getMessageList } from '../../store/action/callback.action'
import FilterList from '../actioncase/actioncase.filterlist'
const { RangePicker } = DatePicker
const { Option } = Select
var form = null

const MessageFilter = (props) => {
  const [open, setOpen] = useState(false)
  var history = useHistory()

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      var values = _.pickBy(data, _.identity)
      values.phone && (values.phone = parseFloat(values.phone))
      values.receivedon &&
        (values.receivedon[0] == 0 && values.receivedon[1] == 0
          ? delete values.receivedon
          : (values.receivedon = {
              max: values.receivedon[1],
              min: values.receivedon[0],
            }))
      values.deleted = values.deleted ? true : false
      console.log(values)
      props.fetchMessages(
        {
          ...values,
          pagination: { pageSize: 20, current: 1 },
          surgeonid: props.filters.surgeonid,
          customer: props.customer._id,
          sort: props.sort,
        },
        {}
      )
      setOpen(false)
    })
  }

  var handleClearFilter = () => {
    props.fetchMessages(
      {
        pagination: { pageSize: 20, current: 1 },
        surgeonid: props.filters.surgeonid,
        customer: props.customer._id,
        sort: props.sort,
      },
      {}
    )
    form && form.resetFields()
  }

  var handleModalOpen = () => {
    form &&
      form.setFieldsValue({
        ...props.filters,
        receivedon: props.filters?.receivedon
          ? [props.filters?.receivedon?.min, props.filters?.receivedon.max]
          : undefined,
      })
    setOpen(true)
  }

  // var getSurgeonSelect = () => {
  //     let options = []
  //     props.surgeons && props.surgeons.forEach((surgeon, i) => {
  //         options.push(
  //             <Option
  //                 key={i+1}
  //                 value={surgeon._id}
  //             >
  //                 {` ${surgeon?.name}`}
  //             </Option>
  //         )
  //     })
  //     return options
  // }

  var renderCard = () => {
    return (
      <Card bordered={false}>
        <Form
          ref={(e) => (form = e)}
          name='normal_login'
          // initialValues={props.filters}
          labelCol={{ span: 7 }}
        >
          <Form.Item
            name='phone'
            label='Phone'
            rules={[
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || value.toString().length == 4) {
                    return Promise.resolve()
                  }
                  return Promise.reject('Please enter 4 digits')
                },
              }),
            ]}
          >
            <Input type='tel' placeholder='Enter Phone' />
          </Form.Item>

          <Form.Item name='receivedon' label='Received On'>
            <RangePicker />
          </Form.Item>

          {/* <Form.Item name="deleted" label="Show Deleted">
                        <Checkbox />
                    </Form.Item> */}
        </Form>
      </Card>
    )
  }

  return (
    <>
      <Row className='filterRow' align={'end'}>
        <Col flex={'auto'}>
          <FilterList />
          {/* <MessageFilterList/> */}
        </Col>
        <Col flex={'20%'}>
          <Row justify={'end'}>
            <Button
              className={'clearBtn'}
              type='primary'
              onClick={handleClearFilter}
              disabled={
                !(props.filters && Object.keys(props.filters).length > 0)
              }
            >
              Clear Filter
            </Button>
            <FilterFilled className={'filterIcon'} onClick={handleModalOpen} />
          </Row>
        </Col>
      </Row>
      <Modal
        className={'filterModal'}
        visible={open}
        closable={false}
        maskClosable={false}
        width={'50%'}
        okText={'Filter'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

MessageFilter.propTypes = {
  fetchPatient: PropTypes.func.isRequired,
  customer: PropTypes.object,
  metadata: PropTypes.object,
  patients: PropTypes.array,
  surgeons: PropTypes.array,
  filters: PropTypes.object,
  sorter: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    pagination: state.message.pagination,
    filters: state.message.filters,
    sort: state.message.sort,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMessages: (filter, selected) =>
      dispatch(getMessageList(filter, selected)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageFilter)
